import { createContext, useContext, ReactNode } from 'react';
import { useTasks } from '../hooks/use-api-tasks';

interface TaskContextValue {
  /** Total tasks for the firm, or null while loading or if the request failed. */
  taskCount: number | null;
}

const TaskContext = createContext<TaskContextValue | null>(null);

export function TaskProvider({ children }: { children: ReactNode }) {
  // limit 1: only pagination.total is needed. Task mutations invalidate ['tasks'], which refreshes it.
  const { data } = useTasks({ limit: 1 });
  const taskCount = data?.pagination.total ?? null;

  return (
    <TaskContext.Provider value={{ taskCount }}>
      {children}
    </TaskContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useTaskContext() {
  const ctx = useContext(TaskContext);
  if (!ctx) throw new Error('useTaskContext must be used within TaskProvider');
  return ctx;
}
